import { Component, OnInit } from '@angular/core';
import { RouterUrlsEnum } from '../../enums/router-urls.enum';

@Component({
  standalone: true,
  selector: 'bodyanalytics-main-nav',
  templateUrl: './main-nav.component.html',
})
export class MainNavComponent {}
